// Karsilama kartinin on dolgusu. Tek kaynak: eskiden LoginForm,
// CustomLoginForm ve WelcomeDialog'da uc ayri kopya vardi.

const { DISTRICT_SUFFIX } = require("./welcomeFields.js");

// Sunucunun urettigi yer tutucular kisi verisi degil: forma dusmemeli.
const PLACEHOLDER_NAME = /^visitor-\d+$/i;
const PLACEHOLDER_EMAIL = "visitor@supsis.live";

const isFilled = (v) => {
    if (v === null || v === undefined) return false;
    const text = String(v).trim();
    if (text === "") return false;
    if (PLACEHOLDER_NAME.test(text)) return false;
    if (text.toLowerCase() === PLACEHOLDER_EMAIL) return false;
    return true;
};

// Yerlesik formun alan adlari; ozel formda input.type ayni isimleri tasiyor.
function fromPredefined(type, predefined) {
    if (!predefined || !predefined.initialized) return undefined;
    if (type === "fullname") return predefined.name || predefined.fullname;
    if (type === "email") return predefined.email;
    if (type === "phone") return predefined.phone;
    return undefined;
}

// Ozel formda saklanan deger input._id ile, yerlesikte alan adiyla eslesiyor.
function fromCustomStorage(field, lastCustomLogins, customLoginVersion) {
    const record = (lastCustomLogins || [])[0];
    if (!record) return undefined;
    // Form surumu degistiyse eski cevaplar artik gecerli degil.
    if (customLoginVersion !== undefined && record.version !== customLoginVersion) return undefined;
    const sourceId = field.sourceId || field.id;
    const match = (record.customLoginFormValues || []).find((v) => String(v.input) === String(sourceId));
    if (!match) return undefined;
    // Il/ilce tek alanda "Il/Ilce" saklaniyor, iki inputa geri aciliyor.
    if (field.input === "city" || field.input === "district") {
        const parts = String(match.value || "").split("/");
        return field.input === "city" ? parts[0] : parts[1];
    }
    return match.value;
}

function resolvePrefill({
    fields,
    preDefinedUserData,
    contactPropertyData,
    lastLoginData,
    lastCustomLogins,
    customLoginVersion,
    queryParams,
} = {}) {
    const out = {};
    (fields || []).forEach((field) => {
        if (field.input === "note") return;
        const type = field.type;
        const candidates = [
            fromPredefined(type, preDefinedUserData),
            (contactPropertyData || {})[type],
            fromCustomStorage(field, lastCustomLogins, customLoginVersion),
            (lastLoginData || {})[type],
            (queryParams || {})[type],
        ];
        const hit = candidates.find(isFilled);
        if (hit !== undefined) out[field.id] = hit;
    });
    return out;
}

module.exports = { resolvePrefill, DISTRICT_SUFFIX };



// WEBPACK FOOTER //
// ./src/utils/welcomePrefill.js